module.exports = __webpack_public_path__ + "static/back-ebb82c440efb8a7b506b3d65a5d95197.jpg";